// TODO - Get this from completed job.
// Used for completed job flow to prepopulate reviews form.
export const SESSION_STORAGE_VALUE_OF_WORK = 'value-of-work';

export const JOB_OPPORTUNITY_INACTIVE_STATUSES = {
  REQUEST_REJECTED: {
    id: 'REQUEST_REJECTED',
    label: 'Declined',
    color: 'negative',
  },
  CANCELLED: { id: 'CANCELLED', label: 'Cancelled', color: 'neutral' },
  WITHDRAWN: { id: 'WITHDRAWN', label: 'Withdrawn', color: 'neutral' },
  COMPLETED: { id: 'COMPLETED', label: 'Completed', color: 'inverted' },
  WORK_FINISHED: {
    id: 'WORK_FINISHED',
    label: 'Completed',
    color: 'inverted',
  },
} as const;

export const JOB_OPPORTUNITY_STATUSES = {
  ...JOB_OPPORTUNITY_INACTIVE_STATUSES,
  REQUESTED: {
    id: 'REQUESTED',
    label: 'Contacted',
    color: 'caution',
  },
  REQUEST_ACCEPTED: {
    id: 'REQUEST_ACCEPTED',
    label: 'Interested',
    color: 'accent',
  },
  QUOTED: {
    id: 'QUOTED',
    label: 'Quoted',
    color: 'accent',
  },
  QUOTED_ACCEPTED: {
    id: 'QUOTED_ACCEPTED',
    label: 'Quoted',
    color: 'accent',
  },
  QUOTED_REJECTED: {
    id: 'QUOTED_REJECTED',
    label: 'Interested',
    color: 'accent',
  },
  SCHEDULED: { id: 'SCHEDULED', label: '', color: 'accent' },
  SCHEDULED_ACCEPTED: {
    id: 'SCHEDULED_ACCEPTED',
    label: 'Booked',
    color: 'accent',
  },
  SCHEDULED_REJECTED: {
    id: 'SCHEDULED_REJECTED',
    label: '',
    color: 'accent',
  },
  BOOKED: {
    id: 'BOOKED',
    label: 'Booked',
    color: 'accent',
  },
} as const satisfies {
  [key: string]: Status;
};

/**
 * What opportunity states can be marked as booked
 */
export const JOB_OPPORTUNITY_BOOKABLE_STATUSES = [
  JOB_OPPORTUNITY_STATUSES.REQUEST_ACCEPTED.id,
  JOB_OPPORTUNITY_STATUSES.SCHEDULED.id,
  JOB_OPPORTUNITY_STATUSES.SCHEDULED_REJECTED.id,
];

/**
 * What opportunity states can be marked as completed
 */
export const JOB_OPPORTUNITY_ALLOW_COMPLETE_STATUSES = [
  ...JOB_OPPORTUNITY_BOOKABLE_STATUSES,
  JOB_OPPORTUNITY_STATUSES.COMPLETED.id,
];

type Status = { id: string; label: string; color: string };

export const JOB_CLOSE_REASON_GROUPS = {
  otherTrade: 'other-trade',
  otherTradeCheckatrade: 'other-trade-checkatrade',
  notProceeding: 'not-proceeding',
} as const;

export const JOB_INACTIVE_STATUSES = {
  CANCELLED: { id: 'CANCELLED', label: 'Cancelled', color: 'neutral' },
  COMPLETED: { id: 'COMPLETED', label: 'Completed', color: 'inverted' },
  WORK_FINISHED: {
    id: 'WORK_FINISHED',
    label: 'Completed',
    color: 'inverted',
  },
  WITHDRAWN: {
    id: 'WITHDRAWN',
    label: 'Cancelled',
    color: 'neutral',
  },
} as const;

export const JOB_STATUSES = {
  ...JOB_INACTIVE_STATUSES,
  REQUESTED: {
    id: 'REQUESTED',
    label: 'Contacted',
    color: 'caution',
  },
  REQUEST_ACCEPTED: {
    id: 'REQUEST_ACCEPTED',
    label: 'Interested',
    color: 'accent',
  },
  QUOTED: {
    id: 'QUOTED',
    label: 'Quoted',
    color: 'accent',
  },
  QUOTED_ACCEPTED: {
    id: 'QUOTED_ACCEPTED',
    label: 'Quoted',
    color: 'accent',
  },
  QUOTED_REJECTED: {
    id: 'QUOTED_REJECTED',
    label: 'Interested',
    color: 'accent',
  },
  SCHEDULED: { id: 'SCHEDULED', label: '', color: 'accent' },
  SCHEDULED_ACCEPTED: {
    id: 'SCHEDULED_ACCEPTED',
    label: 'Booked',
    color: 'accent',
  },
  SCHEDULED_REJECTED: {
    id: 'SCHEDULED_REJECTED',
    label: '',
    color: 'accent',
  },
  BOOKED: {
    id: 'BOOKED',
    label: 'Booked',
    color: 'accent',
  },
} as const satisfies {
  [key: string]: Status;
};
